import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

import Api from "../utils/Api";

// CurrencyActions
export default {
	async initialize()
	{
		const currencies = await Api.getCurrencies();
		const currencyDefinitions = await Api.getCurrencyDefinitions();

		AppDispatcher.dispatch({
			actionType: AppConstants.CURRENCY_INITIALIZE,
			currencies,
			currencyDefinitions
		});
	},

	async saveCurrency(currency)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.CURRENCYSTORE_SAVE_PENDING
		});

		try
		{
			currency = await Api.saveCurrency(currency);
			AppDispatcher.handleAction({
				actionType: AppConstants.CURRENCYSTORE_SAVE_SUCCESS,
				currency
			});
			return currency;
		}
		catch(message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.CURRENCYSTORE_SAVE_FAILURE,
				message
			});
			// TODO: would like to revisit this and make them all more consistent
			// rethrow error for any upstream handlers
			throw message;
		}
	},

	async deleteCurrency(currencyId)
	{
		AppDispatcher.handleAction({
			actionType: AppConstants.CURRENCYSTORE_DELETE_PENDING,
			currencyId
		});

		try
		{
			await Api.deleteCurrency(currencyId);
			AppDispatcher.handleAction({
				actionType: AppConstants.CURRENCYSTORE_DELETE_SUCCESS,
				currencyId
			});
		}
		catch (message)
		{
			AppDispatcher.handleAction({
				actionType: AppConstants.CURRENCYSTORE_DELETE_FAILURE,
				message
			});
			// TODO: would like to revisit this and make them all more consistent
			// rethrow error for any upstream handlers
			throw message;
		}
	}
};



// WEBPACK FOOTER //
// ./Components/actions/CurrencyActions.jsx